import "../styles/ContextMenu.css";
import {useEffect, useState} from "react";

const ContextMenuItem = ({ children, onClick }) => {
    return <div className="ContextMenuItem" onClick={onClick} onContextMenu={e => e.preventDefault()}>{children}</div>
}

const calculatePositionStyle = (x, y) => {
    const style = {};

    if (x < window.innerWidth / 2) style.left = x + 'px';
    else style.right = (window.innerWidth - x) + 'px';

    if (y < window.innerHeight / 2) style.top = y + 'px';
    else style.bottom = (window.innerHeight - y) + 'px';

    return style;
}

const ContextMenu = ({ show, setShow, children }) => {

    const outerStyle = { display: show ? "" : "none" };
    const innerStyle = { display: show ? "" : "none", ...calculatePositionStyle(show?.x ?? 0, show?.y ?? 0,) };

    const [ distance, setDistance ] = useState(0);

    useEffect(() => setDistance(0), [ show ]);

    return (
        <div className="ContextMenu" style={outerStyle} onClick={() => setShow(false)}
             onMouseMove={e => {
                 e.stopPropagation();
                 setDistance(distance+1);

                 if (distance > 10) setShow(false);
             }}>
            <div className="ContextMenuContent" style={innerStyle} onClick={e => e.stopPropagation()} onMouseMove={e => { e.stopPropagation(); setDistance(0); }}>{children}</div>
        </div>
    );
}

export { ContextMenu, ContextMenuItem };
